export class CMSImage {
  imageId?: number;
  language: string;
  type: string;
  url: string;
  source: string;
  blobPath: string;
  width: number;
  height: number;

  constructor() {}
}

export enum CMSImageType {
  Other = "other",
  Logo = "logo",
  Thumbnail = "thumbnail",
  Poster = "poster",
  Banner = "banner",
  Cover = "cover",
}
